import { FranchiseInquiryForm } from "@/features/support";

/**
 * FranchiseInquiryPage - 프랜차이즈 문의 페이지
 */
export function FranchiseInquiryPage() {
  return (
    <div className="min-h-screen bg-white">
      <FranchiseInquiryForm />
    </div>
  );
}
